/*LIBRARY*/
import { useState } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import Dropdown from "../reuseable/Dropdown/Dropdown";

/*REDUX*/
import {
  filter_isi_layer,
  reset_filter,
  undo_filter_isi_layer,
} from "../../App/actions/dataActions";

/*PICTURE*/

/*FUNCTION*/
import format_date_formal from "../../App/validation/format_date_formal";

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/
const format_date_local = (date) => {
  const d = new Date(date);
  let month = "" + (d.getMonth() + 1);
  let day = "" + d.getDate();
  const year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
};

const Filter = ({
  auth,
  layer,
  filter_isi_layer,
  reset_filter,
  undo_filter_isi_layer,
}) => {
  const [filter_fields, set_filter_fields] = useState("");
  const [filter_name, set_filter_name] = useState("");
  const [filter_value, set_filter_value] = useState("");
  const [field_obj, set_field_obj] = useState({});
  const [start_date, set_start_date] = useState(
    format_date_local(new Date(Date.now())),
  );
  const [end_date, set_end_date] = useState(
    format_date_local(new Date(Date.now())),
  );

  const language = localStorage?.language || auth.language;
  const { layer_id, geo_layer_list } = layer;

  let geo_layer = geo_layer_list.find((e) => e?.geo_layer?._id === layer_id);
  geo_layer = geo_layer?.geo_layer ? geo_layer.geo_layer : {};
  let fields = geo_layer?.fields ? geo_layer.fields : [];

  const on_reset_filter = () => {
    const body = { geo_layer_id: layer_id };
    reset_filter(body);
  };

  const on_filter_isi_layer = (field_key, value) => {
    let body = {};
    if (field_obj.type === "date") {
      body = {
        geo_layer_id: layer_id,
        start_date,
        end_date,
        field_key,
      };
    } else {
      body = {
        geo_layer_id: layer_id,
        field_key,
        value,
      };
    }

    filter_isi_layer(body);
    set_filter_fields("");
    set_filter_value("");
    set_field_obj({});
  };

  const on_undo_filter_isi_layer = (field_key, value) => {
    const body = {
      geo_layer_id: layer_id,
      field_key,
      value,
    };
    undo_filter_isi_layer(body);
    set_filter_fields("");
    set_filter_value("");
    set_field_obj({});
  };

  const handle_filter_fields_change = (value) => {
    const fields_obj = fields.find((f) => f.key === value) || {};

    set_filter_fields(value);
    set_field_obj(fields_obj);
    set_filter_name(fields_obj.name || "");
  };

  const get_sorted_options = (field_key) => {
    if (!field_key || !geo_layer?.geojson?.features) return [];

    const temp_set = new Set();

    geo_layer.geojson.features.forEach((feature) => {
      const raw_val = feature?.properties?.[field_key];
      if (raw_val) {
        // Convert to string, split by newline, and clean up spaces
        String(raw_val)
          .split("\n")
          .forEach((val) => {
            const clean_val = val.trim();
            if (clean_val) temp_set.add(clean_val); // Add to Set (prevents duplicates)
          });
      }
    });

    // Convert the Set back to an array and sort it alphabetically
    return Array.from(temp_set).sort();
  };

  const sort_data = get_sorted_options(filter_fields);

  const option_fields = fields.filter(
    (f) => !f.isStyle && !f.parent_uuid && f.type !== "table",
  );

  const filtered_fields = fields
    .map((f) => ({
      ...f,
      array_value_filter: f?.array_value_filter ? f.array_value_filter : [],
    }))
    .filter((f) => {
      let logic = f?.array_value_filter?.length > 0;
      if (f.type === "date") {
        logic = f.start_date;
      } else {
        logic = f?.array_value_filter?.length > 0;
      }
      return logic;
    });

  return (
    <div className="container background_white outline_black margin_bottom">
      <main>
        <p className="text_bold margin_bottom">
          {dict["Select a column to filter"]?.[language] ||
            "Select a column to filter"}
        </p>

        <section className="outline_grey" style={{ borderRadius: "9px" }}>
          <Dropdown
            placeholder={dict["Select column"]?.[language] || "Select column"}
            filter_on
            is_enable_empty={false}
            value={filter_fields}
            onChange={(value) => handle_filter_fields_change(value)}
            data-mapid="selectType1"
          >
            {option_fields.map((d, idx) => {
              return (
                <option key={d.key} value={d.key} id={idx}>
                  {d.name}
                </option>
              );
            })}
          </Dropdown>
        </section>
      </main>

      {filter_fields && (
        <div>
          <p className="text_bold margin_bottom">
            {dict["Choose"]?.[language] || "Choose"} {field_obj?.name}
          </p>
          {field_obj.type === "date" ? (
            <div>
              <p className="text_medium sub_color margin_bottom">Start</p>
              <input
                type="date"
                onChange={(e) => set_start_date(e.target.value)}
                id="start_date"
                name="start_date"
                value={start_date}
                className="margin_bottom"
              />
              <p className="text_medium sub_color margin_bottom">End</p>
              <input
                type="date"
                onChange={(e) => set_end_date(e.target.value)}
                id="end_date"
                name="end_date"
                value={end_date}
                className="margin_bottom"
              />
            </div>
          ) : (
            <main>
              <input
                list="filter_persungai"
                id="filter_value"
                name="filter_value"
                onChange={(e) => set_filter_value(e.target.value)}
                value={filter_value}
                placeholder={`${dict["Choose"]?.[language] || "Choose"} ${filter_name}...`}
                data-mapid="selectType2"
              />
              <datalist id="filter_persungai">
                {sort_data.map((d) => (
                  <option value={d} key={d}>
                    {d}
                  </option>
                ))}
              </datalist>
            </main>
          )}
        </div>
      )}

      {(filter_fields && filter_value) ||
      (filter_fields && end_date) ||
      (filter_fields && start_date) ? (
        <button
          className="button background_black margin_top margin_bottom"
          onClick={() => on_filter_isi_layer(filter_fields, filter_value)}
          data-mapid="clickFilter"
        >
          {dict["Filter"]?.[language] || "Filter"}
        </button>
      ) : null}

      <section>
        <p className="text_bold margin_bottom">
          {dict?.["Filtered parameters:"]?.[language] || "Filtered parameters:"}
        </p>
        <button
          className="button margin_bottom background_black"
          onClick={on_reset_filter}
          data-mapid="clickResetFilter"
        >
          Clear Filter
        </button>
        <table className="table full_width">
          <tbody>
            {filtered_fields.map((f) => {
              let content;
              if (f.type === "date") {
                content = (
                  <>
                    <p>Start: {format_date_formal(f.start_date)}</p>
                    <p>End: {format_date_formal(f.end_date)}</p>
                  </>
                );
              } else {
                content = f.array_value_filter.map((value, index) => (
                  <span
                    className="text_small margin_right margin_bottom"
                    key={`${f.key}-${value}-${index}`}
                    onClick={() => on_undo_filter_isi_layer(f.key, value)}
                    data-mapid={`clickEachClear-${index}`}
                  >
                    {value}{" "}
                    <button className="button_small background_black">X</button>
                  </span>
                ));
              }
              return (
                <tr key={f.key}>
                  <td>{f.name}</td>
                  <td>{content}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </section>
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  layer: state.layer,
});

export default connect(mapStateToProps, {
  filter_isi_layer,
  reset_filter,
  undo_filter_isi_layer,
})(Filter);
